import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { BackupFileDownloaderService } from './backup-file-downloader.service';

import { SvgIconComponent } from '../icons/svg-icon.component';

@Component({
    selector: 'ep-backup-file-downloader',
    templateUrl: './backup-file-downloader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent]
})
export class BackupFileDownloaderComponent implements OnChanges {

    @Input() fileIdentifier: string;
    @Input() fileType: string;
    public fileName: string = 'Not available';
    public fileFound: boolean = false;
    public showDownloadIndicator = false;

    constructor(private backupFileDownloader: BackupFileDownloaderService) { }

    public ngOnChanges(changes: any) {
        if ((changes.fileIdentifier || changes.fileType)) {
            this.fileName = 'Loading filename...';
            if (this.fileIdentifier && this.fileType) {
                this.backupFileDownloader.getFilename(this.fileIdentifier, this.fileType).then((filename: string) => {
                    if (filename) {
                        this.fileName = filename;
                        this.fileFound = true;
                    }
                    else {
                        this.fileName = 'Not available';
                        this.fileFound = false;
                    }
                }).catch(() => {
                    this.fileName = 'Not available';
                });
            }
            else {
                this.fileName = 'Not available';
                this.fileFound = false;
            }
        }
    }

    downloadFile() {
        if (!this.fileIdentifier || !this.fileType) {
            throw Error('Invalid fileIdentifier or fileType provided!');
        }

        this.showDownloadIndicator = true;
        this.backupFileDownloader.downloadFile(this.fileIdentifier, this.fileType).then(() => {
            this.showDownloadIndicator = false;
        }).catch(() => { this.showDownloadIndicator = false; });
    }
}